import * as coreCommon from 'assets/core/js/common'
import Modal, { type ModalConfig } from 'assets/core/js/module/modal'
import SnackbarManager from 'assets/core/js/module/snackbarManager'

export default class ShareModal extends Modal {
  methodsEl!: Element
  shareData!: ShareData

  constructor(element: string | HTMLElement, config: ModalConfig = {}) {
    super(element, config)

    if (!this.element) {
      return
    }

    this.methodsEl = this.element.querySelector('.dca-share-modal__methods') as Element

    this.shareData = {
      text: this.methodsEl.getAttribute('data-share-modal-text') as string,
      url: atob(this.methodsEl.getAttribute('data-share-modal-mobile-url') as string),
    }

    this.initMethods()
  }

  getElement(): HTMLElement {
    return this.element
  }

  open(): Modal {
    const isMobile = coreCommon.isIOS() || coreCommon.isAndroid()

    if (navigator.canShare?.(this.shareData) && isMobile) {
      navigator
        .share(this.shareData)
        .then(() => true)
        .catch(/* istanbul ignore next */ () => true)
    } else {
      super.open()
    }

    return this
  }

  initMethods(): void {
    const snackbarEl = document.getElementById('share-modal-snackbar') as HTMLElement

    this.methodsEl.querySelectorAll('.dca-share-modal__method').forEach((el) => {
      el.addEventListener('click', () => {
        const method = el.getAttribute('data-share-method')

        if (!el.hasAttribute('data-share-method-url')) {
          return
        }

        const methodUrl = atob(el.getAttribute('data-share-method-url') as string)

        switch (method) {
          case 'link': {
            SnackbarManager.initSnackbar(snackbarEl)

            if (navigator.clipboard) {
              navigator.clipboard
                .writeText(methodUrl)
                .then(() => true)
                .catch(/* istanbul ignore next */ () => true)
            }

            break
          }

          default: {
            window.open(methodUrl)
            break
          }
        }
      })
    })
  }
}
